import React from 'react';
import axios from 'axios';
import { rollbar } from './Rollbar.js'
import { AddressDetails } from './Address/AddressDetails';
import { ProductDetails } from './Product/ProductDetails';
import { AddonSelection } from './Product/AddonSelection';
import { CustomerDetails } from './CustomerDetails';
import { CompanyDetails } from './CompanyDetails';

export class SignUp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            selectedAddress: null,
            availabilitySummary: null,
            selectedProduct: null,
            selectedRouter: null,
            selectedAddonIds: [],
            selectedVoipAddonIds: [],
            selectedRecurringAddonIds: [],
            voipPhone: '',
            customerDetails: null,
            loading: true,
            error: false,
            sureSwitchProviders: null,
            business: this.props.business !== undefined ? this.props.business : false,
            referralCode: this.props.match?.params.referralCode
        };

        this.handleAddressClick = this.handleAddressClick.bind(this);
        this.handleAddressReset = this.handleAddressReset.bind(this);
        this.handleProductClick = this.handleProductClick.bind(this);
        this.handleAddonsConfirmed = this.handleAddonsConfirmed.bind(this);
        this.handleBusinessClick = this.handleBusinessClick.bind(this);
        this.handleResidentialClick = this.handleResidentialClick.bind(this);
    }

    async componentDidMount() {
        var url = process.env.REACT_APP_THIRTEEN_TEN_API + '/sureswitch';
        await axios.get(url)
            .then(response => {
                this.setState({ sureSwitchProviders: response.data });
                console.log(response.data);
            })
            .catch(error => {
                rollbar.error(error);
                this.setState({ error: true });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    handleBusinessClick() {
        this.setState({
            business: true
        });
    }

    handleResidentialClick() {
        this.setState({
            business: false
        });
    }

    handleAddressClick(newSelectedAddress) {
        this.setState({
            step: 2,
            selectedAddress: newSelectedAddress,
            availabilitySummary: null,
            selectedProductId: 0,
            selectedRouterId: 0,
            localPopId: 0,
            locationId: 0
        });
    }

    handleAddressReset() {
        this.setState({
            step: 1,
            selectedAddress: null,
            availabilitySummary: null,
            selectedProduct: null,
            selectedRouter: null,
            selectedAddonIds: [],
            selectedVoipAddonIds: [],
            selectedRecurringAddonIds: [],
            voipPhone: ''
        });
    }

    handleProductClick(newSelectedProduct, newSelectedRouter, routerSelected = false) {
        const isPreorder = newSelectedProduct?.preorder ?? false;
        const nextStep = routerSelected ? (isPreorder ? 4 : 3) : 2;
        console.log('[SignUp] handleProductClick', { routerSelected, isPreorder, nextStep, locationId: newSelectedProduct?.locationId, productId: newSelectedProduct?.productId });
        this.setState({
            selectedProduct: newSelectedProduct,
            selectedRouter: newSelectedRouter,
            selectedAddonIds: [],
            selectedVoipAddonIds: [],
            selectedRecurringAddonIds: [],
            voipPhone: '',
            step: nextStep,
            business: newSelectedProduct == null ? false : newSelectedProduct.businessOnly
        });
    }

    handleAddonsConfirmed(productAddonIds, voipAddonIds, recurringAddonIds, voipPhone) {
        console.log('[SignUp] handleAddonsConfirmed', { productAddonIds, voipAddonIds, recurringAddonIds, voipPhone });
        this.setState({ selectedAddonIds: productAddonIds, selectedVoipAddonIds: voipAddonIds, selectedRecurringAddonIds: recurringAddonIds, voipPhone, step: 4 });
    }

    render() {
        if (this.state.loading) {
            return (
                <div className="App m-5">
                    <div className="fa-2x">
                        <i className="fas fa-spinner fa-pulse"></i>
                    </div>
                </div>
            );
        }
        else return (
            <div className="App m-5">
                {
                    this.state.step >= 1 &&
                    <AddressDetails onClick={this.handleAddressClick} onReset={this.handleAddressReset} />
                }
                {
                    this.state.step >= 2 &&
                    <ProductDetails selectedAddress={this.state.selectedAddress} onClick={this.handleProductClick} business={this.state.business}
                        showSetupFee={true} discountCode={this.state.discountCode} />
                }
                {
                    this.state.step >= 3 && !this.state.selectedProduct?.preorder &&
                    <AddonSelection
                        locationId={this.state.selectedProduct?.locationId}
                        tariffId={this.state.selectedProduct?.productId}
                        routerId={this.state.selectedRouter?.id ?? 0}
                        selectedRouter={this.state.selectedRouter}
                        selectedProduct={this.state.selectedProduct}
                        onContinue={this.handleAddonsConfirmed} />
                }
                {
                    this.state.step >= 4 && !this.state.business &&
                    <CustomerDetails selectedProduct={this.state.selectedProduct} selectedRouter={this.state.selectedRouter}
                        selectedAddonIds={this.state.selectedAddonIds}
                        selectedVoipAddonIds={this.state.selectedVoipAddonIds}
                        selectedRecurringAddonIds={this.state.selectedRecurringAddonIds}
                        voipPhone={this.state.voipPhone}
                        selectedAddress={this.state.selectedAddress} referralCode={this.state.referralCode}
                        onBusinessClick={this.handleBusinessClick} showSetupFee={true} sureSwitchProviders={this.state.sureSwitchProviders} />
                }
                {
                    this.state.step >= 4 && this.state.business &&
                    <CompanyDetails selectedProduct={this.state.selectedProduct} selectedRouter={this.state.selectedRouter}
                        selectedAddonIds={this.state.selectedAddonIds}
                        selectedVoipAddonIds={this.state.selectedVoipAddonIds}
                        selectedRecurringAddonIds={this.state.selectedRecurringAddonIds}
                        voipPhone={this.state.voipPhone}
                        selectedAddress={this.state.selectedAddress} referralCode={this.state.referralCode}
                        onResidentialClick={this.handleResidentialClick} showSetupFee={true} sureSwitchProviders={this.state.sureSwitchProviders} />
                }
            </div>
        )
    }
}
